import { memo } from 'react';

import ProductImage from '@Components/ProductImage';

import type { FC, HTMLAttributes } from 'react';
import type { ProductData } from '@Types/Product';

export interface ContentProps extends HTMLAttributes<HTMLDivElement> {
  styles?: string;
  product?: ProductData;
}

const Content: FC<ContentProps> = (props) => {
  const { styles, product, ...restProps } = props;
  const images = product.images || [];
  const [firstImage] = images;

  return (
    <div {...restProps}>
      <ProductImage className={styles} src={firstImage?.src} />
    </div>
  );
};

export default memo(Content);
